import { create } from 'zustand'
import { TESTNET_CHAIN_ID, TESTNET_RPC_URL } from '../utils/constants'

type State = {
    environment: 'Wallet' | 'Manual' | 'Remote Devnet',
    rpcUrl: string,
    publicKey: string,
    privateKey: string,
    userKey: string,
    balance: bigint
}

type Action = {
    updateEnvironment: (environment: State['environment']) => void
    updateRpcUrl: (chainId: number) => void
    updatePublicKey: (publicKey: State['publicKey']) => void
    updatePrivateKey: (privateKey: State['privateKey']) => void
    updateUserKey: (userKey: State['userKey']) => void
    updateBalance: (balance: State['balance']) => void
}

const initialState: State = {
    environment: window.ethereum === undefined ? 'Manual' : 'Wallet',
    rpcUrl: TESTNET_RPC_URL,
    publicKey: '',
    privateKey: '',
    userKey: '',
    balance: BigInt(0)
}

export const useEnvironmentStore = create<State & Action>()((set) => ({
    ...initialState,
    updateEnvironment: (environment) => set(() => ({ environment: environment })),
    updateRpcUrl: (chainId: number) => {
        let nodeUrl = ''

        if (chainId === TESTNET_CHAIN_ID) {
            nodeUrl = TESTNET_RPC_URL
        }

        set(() => ({ rpcUrl: nodeUrl }))
    },
    updatePublicKey: (publicKey) => set(() => ({ publicKey: publicKey })),
    updatePrivateKey: (privateKey) => set(() => ({ privateKey: privateKey })),
    updateUserKey: (userKey) => set(() => ({ userKey: userKey })),
    updateBalance: (balance) => set(() => ({ balance: balance }))
}))